import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AnalyticsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"analytics"}/>
}
